/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type PopularSearchItemDto = {
    term: string;
    type: PopularSearchItemDto.type;
    /**
     * Present when type = service_type
     */
    serviceTypeId?: string;
};
export namespace PopularSearchItemDto {
    export enum type {
        SERVICE_TYPE = 'service_type',
        KEYWORD = 'keyword',
    }
}

